import { http } from "./http";

export type ClinicInfoItem = {
  id: number;
  name: string;
  detail: string;
};

export async function fetchClinicInfo(): Promise<ClinicInfoItem[]> {
  const { data } = await http.get<unknown>("/clinic-info");
  return Array.isArray(data) ? (data as ClinicInfoItem[]) : [];
}

export async function createClinicInfo(name: string, detail: string) {
  const { data } = await http.post<ClinicInfoItem>("/clinic-info", { name, detail });
  return data;
}

export async function updateClinicInfo(id: number, name: string, detail: string) {
  const { data } = await http.patch<ClinicInfoItem>(`/clinic-info/${id}`, { name, detail });
  return data;
}

